"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertTrixImagesToSimpleImgTags = exports.fixNonSelfClosingIframes = exports.removeExtraSpaces = exports.removeRedundantBoldTextAndSpacing = exports.deepEquals = exports.fixDoubleSpacesInHtml = exports.normalizeType = void 0;
const deepEqual = require('deep-equal');
const normalizeType = (type) => type.toLowerCase();
exports.normalizeType = normalizeType;
const fixDoubleSpacesInHtml = (html) => html && html.replace
    ? html.replace(/<\s*p[^>]*>([^<]*)<\s*\/\s*p\s*>/g, (str) => str.replace(/  /g, ' &nbsp;'))
    : html;
exports.fixDoubleSpacesInHtml = fixDoubleSpacesInHtml;
const deepEquals = (a, b) => deepEqual(a, b);
exports.deepEquals = deepEquals;
const removeRedundantBoldTextAndSpacing = (html, parser) => {
    const $ = parser;
    const dummyDiv = $('<div>').html(html);
    const text = dummyDiv.text();
    const firstWord = text.trim().split(' ')[0].trim();
    const boldNode = dummyDiv.find('b, strong').first();
    if (firstWord.indexOf(boldNode.text().replace(':', '').trim()) > -1) {
        boldNode.remove();
    }
    if (dummyDiv.text().trim()[0] === ':') {
        dummyDiv.html(dummyDiv.html().replace(':', ''));
    }
    dummyDiv.children().each((_i, e) => {
        const elem = $(e);
        if (elem.text().trim().length === 0) {
            elem.remove();
        }
    });
    dummyDiv.html((0, exports.removeExtraSpaces)(dummyDiv.html(), $));
    return dummyDiv.html().trim();
};
exports.removeRedundantBoldTextAndSpacing = removeRedundantBoldTextAndSpacing;
const removeExtraSpaces = (html, parser) => {
    const $ = parser;
    const dummyDiv = $('<div>').html(html);
    dummyDiv.find('p').each(function () {
        const $this = $(this);
        if ($this.html().replace(/\s|&nbsp;/g, '').length === 0) {
            $this.remove();
        }
        else {
            $this.html($this.html().trim());
        }
    });
    return dummyDiv.html().trim();
};
exports.removeExtraSpaces = removeExtraSpaces;
const fixNonSelfClosingIframes = (html) => html.replace(/<iframe([\s\S][^>]*)\/>/gm, '<iframe$1></iframe>');
exports.fixNonSelfClosingIframes = fixNonSelfClosingIframes;
const TRIX_ATTACHMENT_SELECTOR = '[data-trix-attachment]';
const TRIX_IMAGE_CONTENT_TYPE = 'image';
const TRIX_FIGURE_ELEMENT_SELECTOR = 'figure.attachment.attachment-preview';
const convertTrixImagesToSimpleImgTags = (html, parser) => {
    const $ = parser;
    const $node = $('<div></div>').html(html);
    $node.find(TRIX_ATTACHMENT_SELECTOR).each((_, el) => {
        const trixImage = $(el);
        if (trixImage.data().trixContentType === TRIX_IMAGE_CONTENT_TYPE) {
            const url = trixImage.data().trixAttachment.url;
            const img = `<img src=${url}>`;
            const maybeLinkParent = trixImage.closest('a');
            if (maybeLinkParent.length) {
                maybeLinkParent.html(img);
            }
            else {
                const figureParent = trixImage.closest(TRIX_FIGURE_ELEMENT_SELECTOR);
                figureParent.next().remove();
                figureParent.prev().remove();
                figureParent.replaceWith(img);
            }
        }
    });
    return $node.html();
};
exports.convertTrixImagesToSimpleImgTags = convertTrixImagesToSimpleImgTags;
